import { render, staticRenderFns } from "./OrderListPre.vue?vue&type=template&id=2d08cb6a&scoped=true"
import script from "./OrderListPre.vue?vue&type=script&lang=js"
export * from "./OrderListPre.vue?vue&type=script&lang=js"
import style0 from "./OrderListPre.vue?vue&type=style&index=0&id=2d08cb6a&prod&scoped=true&lang=css"
import style1 from "./OrderListPre.vue?vue&type=style&index=1&id=2d08cb6a&prod&less=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d08cb6a",
  null
  
)

export default component.exports